import { Country, NationalityCountry } from 'models/country';
import { RestCountryResponse } from 'models/restCountry';

import { Reset } from './generic';

export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';
export const LOAD_COUNTRY_LIST = 'LOAD_COUNTRY_LIST';
export const LOADING_COUNTRIES = 'LOADING_COUNTRIES';

export const LOAD_NATIONALITY_COUNTRIES = 'LOAD_NATIONALITY_COUNTRIES';
export const LOADING_NATIONALITY_COUNTRIES = 'LOADING_NATIONALITY_COUNTRIES';

export const LOAD_REST_COUNTRIES = 'LOAD_REST_COUNTRIES';
export const LOADING_REST_COUNTRIES = 'LOADING_REST_COUNTRIES';

export interface ChangeLanguage {
  type: typeof CHANGE_LANGUAGE;
  country: Country;
}

export interface LoadCountryList {
  type: typeof LOAD_COUNTRY_LIST;
  countries: Country[];
}

export interface LoadingCountryList {
  type: typeof LOADING_COUNTRIES;
  loading: boolean;
}

export interface LoadNationalyCountryList {
  type: typeof LOAD_NATIONALITY_COUNTRIES;
  countries: NationalityCountry[];
}

export interface LoadingNationalyCountryList {
  type: typeof LOADING_NATIONALITY_COUNTRIES;
  loading: boolean;
}

export interface LoadRestCountryList {
  type: typeof LOAD_REST_COUNTRIES;
  countries: RestCountryResponse[];
}

export interface LoadingRestCountryList {
  type: typeof LOADING_REST_COUNTRIES;
  loading: boolean;
}

export type I18nActions =
  | ChangeLanguage
  | LoadCountryList
  | LoadingCountryList
  | LoadNationalyCountryList
  | LoadingNationalyCountryList
  | LoadRestCountryList
  | LoadingRestCountryList
  | Reset;

export const doChangeLanguage = (country: Country): I18nActions => ({
  type: CHANGE_LANGUAGE,
  country,
});

export const doLoadCountryList = (countries: Country[]): I18nActions => ({
  type: LOAD_COUNTRY_LIST,
  countries,
});

export const doLoadingCountryList = (loading: boolean): I18nActions => ({
  type: LOADING_COUNTRIES,
  loading,
});

export const doLoadNationalityCountryList = (countries: NationalityCountry[]): I18nActions => ({
  type: LOAD_NATIONALITY_COUNTRIES,
  countries,
});

export const doLoadingNationalityCountryList = (loading: boolean): I18nActions => ({
  type: LOADING_NATIONALITY_COUNTRIES,
  loading,
});

export const doLoadRestCountryList = (countries: RestCountryResponse[]): I18nActions => ({
  type: LOAD_REST_COUNTRIES,
  countries,
});

export const doLoadingRestCountryList = (loading: boolean): I18nActions => ({
  type: LOADING_REST_COUNTRIES,
  loading,
});
